import { render, staticRenderFns } from "./JobAssignmentOrderForm.vue?vue&type=template&id=b621fd6c&scoped=true&"
import script from "./JobAssignmentOrderForm.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621fd6c",
  null
  
)

export default component.exports